import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Card, Input, Space, Table, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppConfig } from "../../shared/config/AppConfigProvider";
import { formatDate, formatDateTime } from "../../shared/utils/formatters";
import { customerName } from "../customers/customer-types";
import { repairOrdersApi } from "./repair-orders-api";
import { RepairOrderStatusTag } from "./repair-order-status";
import { useTimedNoResults } from "../../shared/hooks/useTimedNoResults";

export function RepairOrderListPage() {
  const { text } = useAppConfig();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const orders = useQuery({ queryKey: ["repair-orders", query, page], queryFn: () => repairOrdersApi.list(query, undefined, page) });
  const noSearchResultsDismissed = useTimedNoResults({
    query,
    enabled: Boolean(query.trim()),
    loading: orders.isFetching,
    ready: Boolean(orders.data),
    hasResults: Boolean(orders.data?.items.length)
  });
  return <section>
    <div className="page-title business-page-title">
      <div><Typography.Title level={2}>{text.repairOrders}</Typography.Title><Typography.Paragraph type="secondary">{text.repairOrderListHint}</Typography.Paragraph></div>
      <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate("/repair-orders/new")}>{text.newRepairOrder}</Button>
    </div>
    <Card>
      <Space.Compact className="list-search">
        <Input value={search} allowClear prefix={<SearchOutlined />} placeholder={`${text.search} RO, VIN, customer…`} onChange={event => setSearch(event.target.value.toUpperCase())} onPressEnter={() => { setPage(1); setQuery(search); }} />
        <Button onClick={() => { setPage(1); setQuery(search); }}>{text.search}</Button>
      </Space.Compact>
      <Table
        rowKey="id"
        loading={orders.isLoading}
        dataSource={orders.data?.items ?? []}
        locale={{ emptyText: query && noSearchResultsDismissed ? null : text.noSearchResults }}
        rowClassName="clickable-row"
        onRow={row => ({ onClick: () => navigate(`/repair-orders/${row.id}/workspace`) })}
        scroll={{ x: 1050 }}
        pagination={{ current: page, pageSize: 20, total: orders.data?.total ?? 0, showSizeChanger: false, onChange: setPage }}
        columns={[
          { title: "RO", dataIndex: "roNumber", key: "number", render: value => <b>{value}</b> },
          { title: text.status, dataIndex: "status", key: "status", render: value => <RepairOrderStatusTag status={value} /> },
          { title: text.customer, key: "customer", render: (_, row) => customerName(row.customer) },
          { title: text.vehicle, key: "vehicle", render: (_, row) => <div>{row.vehicle.year} {row.vehicle.make} {row.vehicle.model}<small className="table-secondary mono">{row.vehicle.vin}</small></div> },
          { title: text.promisedAt, dataIndex: "promisedAt", key: "promised", render: formatDateTime },
          { title: text.time, dataIndex: "openedAt", key: "opened", render: formatDate }
        ]}
      />
    </Card>
  </section>;
}
